import { Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
// import { AlertOptions, AlertService } from '../components/ui/alert/alert.service';
// import { ApiService } from './api.service';
import { Subject } from 'rxjs';
import { EMVResponse } from './components/EMVModule.service';
import { StorageService } from './storage.service';
import { TraceService } from './trace.service';

export interface Step {
  key: string,
  url: string,
  next: string | null,
  prev: string | null,
  navigate?: boolean,
}
const CARD_WITHDRAWAL = [
  {
    key: 'CWD:START',
    url: '/kiosk/cash-withdrawal/confirm-fee',
    next: 'CWD:AMOUNT_OPTIONS',
    prev: "WELCOME",
  },
  {
    key: 'CWD:AMOUNT_OPTIONS',
    url: '/kiosk/cash-withdrawal/amount',
    next: 'CWD:CONFIRM_WITHDRAW',
    prev: 'CWD:START',
  },
  {
    key: 'CWD:CUSTOM_AMOUNT',
    url: '/kiosk/cash-withdrawal/custom',
    next: 'CWD:CONFIRM_WITHDRAW',
    prev: 'CWD:AMOUNT_OPTIONS',
  },
  {
    key: 'CWD:CONFIRM_WITHDRAW',
    url: '/kiosk/cash-withdrawal/confirm',
    next: 'CWD:PROCESS_CARD',
    prev: 'CWD:AMOUNT_OPTIONS',
  },
  {
    key: 'CWD:PROCESS_CARD',
    url: '/kiosk/cash-withdrawal/card',
    next: 'RESULT',
    prev: 'CWD:CONFIRM_WITHDRAW',
  },
] as const;
const CARD_DEPOSIT = [
  {
    key: 'CDD:START',
    url: '/kiosk/cash-deposit/confirm-fee',
    next: 'CDD:PROCESS_CARD',
    prev: "WELCOME",
  },
  {
    key: 'CDD:PROCESS_CARD',
    url: '/kiosk/cash-deposit/card',
    next: 'CDD:CONFIRM_DEPOSIT',
    prev: 'CDD:START',
  },
  {
    key: 'CDD:CONFIRM_DEPOSIT',
    url: '/kiosk/cash-deposit/confirm',
    next: 'RESULT',
    prev: 'CDD:PROCESS_CARD',
  },
] as const;
const WESTERN_UNION_SEND = [
  {
    key: 'WU:RECENT_LIST',
    url: '/kiosk/western-union/send/recent-list',
    next: 'WU:SEND_SECURITY_QUESTION',
    prev: 'WU:EXISTING_CUSTOMER',
  },
  {
    key: 'WU:SEND_SECURITY_QUESTION',
    url: '/kiosk/western-union/send/security-question',
    next: 'WU:DEPOSIT',
    prev: 'WU:RECENT_LIST',
  },
  // {
  //   key: 'WU:ENTER_AMOUNT',
  //   url: '/kiosk/western-union/send/enter-amount',
  //   next: 'WU:DEPOSIT',
  //   prev: 'WU:SEND_SECURITY_QUESTION',
  // },
  {
    key: 'WU:DEPOSIT',
    url: '/kiosk/western-union/send/deposit',
    next: 'RESULT',
    prev: 'WU:SEND_SECURITY_QUESTION',
  },
  {
    key: 'WU:ADD_RECEIVER',
    url: '/kiosk/western-union/send/add-receiver',
    next: 'WU:ADD_RECEIVER_MANUAL',
    prev: 'WU:RECENT_LIST',
  },
  {
    key: 'WU:ADD_RECEIVER_MANUAL',
    url: '/kiosk/western-union/send/add-receiver-manual',
    next: 'RESULT',
    prev: 'WU:ADD_RECEIVER',
  },
  // {
  //   key: 'WU:SEND',
  //   url: '/kiosk/western-union/send',
  //   next: null,
  //   prev: 'WU:EXISTING_CUSTOMER',
  // },
]
const WESTERN_UNION_RECEIVE = [
  {
    key: 'WU:MTCN',
    url: '/kiosk/western-union/receive/enter-mtcn',
    next: 'WU:RECEIVE_SECURITY_QUESTION',
    prev: 'WU:EXISTING_CUSTOMER',
  },
  {
    key: 'WU:RECEIVE_SECURITY_QUESTION',
    url: '/kiosk/western-union/receive/security-question',
    next: 'WU:WITHDRAW',
    prev: 'WU:MTCN',
  },
  // {
  //   key: 'WU:RECEIVE_ACCEPT_FEE',
  //   url: '/kiosk/western-union/receive/accept-fee',
  //   next: 'WU:WITHDRAW',
  //   prev: 'WU:RECEIVE_SECURITY_QUESTION',
  // },
  {
    key: 'WU:WITHDRAW',
    url: '/kiosk/western-union/receive/withdraw',
    next: 'RESULT',
    prev: 'WU:RECEIVE_SECURITY_QUESTION',
  },
]
const WESTERN_UNION_ESTIMATE = [
  {
    key: 'WU:ESTIMATE_AMOUNT',
    url: '/kiosk/western-union/estimate/amount',
    next: 'WU:ESTIMATE_COUNTRY',
    prev: 'WU:EXISTING_CUSTOMER',
  },
  {
    key: 'WU:ESTIMATE_COUNTRY',
    url: '/kiosk/western-union/estimate/country',
    next: 'WU:ESTIMATE_RESULT',
    prev: 'WU:ESTIMATE_AMOUNT',
  },
  {
    key: 'WU:ESTIMATE_RESULT',
    url: '/kiosk/western-union/estimate/result',
    next: null,
    prev: 'WU:ESTIMATE_COUNTRY',
  },
]
const WESTERN_UNION = [
  {
    key: 'WU:START',
    url: '/kiosk/western-union/mobile-number',
    next: "WU:KYC_CHECK",
    prev: "WELCOME",
  },
  {
    key: 'WU:KYC_CHECK',
    url: '/kiosk/western-union/kyc-check',
    next: null,
    prev: 'WU:START',
  },
  {
    key: 'WU:EXISTING_CUSTOMER',
    url: '/kiosk/western-union/existing-customer',
    next: null,
    prev: 'WU:START',
  },
  {
    key: 'WU:NEW_CUSTOMER',
    url: '/kiosk/western-union/new-customer',
    next: null,
    prev: 'WU:START',
  },
  ...WESTERN_UNION_SEND,
  ...WESTERN_UNION_RECEIVE,
  ...WESTERN_UNION_ESTIMATE
] as const;

const STEPS = [
  {
    key: 'WELCOME',
    url: '/kiosk/welcome',
    next: null,
    prev: null,
  },
  {
    key: 'RESULT',
    url: '/kiosk/result',
    next: null,
    prev: null,
  },
  ...CARD_WITHDRAWAL,
  ...CARD_DEPOSIT,
  ...WESTERN_UNION
] as const
type Steps = (typeof STEPS)
// type FilteredStep<Source extends Steps, Key extends StepKey, K extends keyof Source[number]> =
//   { [I in keyof Source]: Source[I][K] extends Key ? Source[I] : never } // doesnt work on installed ts?
export type StepKey = Steps[number]['key'];
type Action = {
  name: string,
  data: any
} | {
  name: "DO_SALE_SUCCESS",
  data: EMVResponse
} | {
  name: "DO_SALE_FAILED",
  data: string
}
@Injectable({
  providedIn: 'root'
})
export class UiService {
  steps = STEPS;
  navigate$ = new Subject<Step>();
  action$ = new Subject<Action>();
  errors$ = new Subject<string[]>();
  option$ = new Subject<string>();
  options$ = new Subject<{
    name: string,
    items: { value: string, display: string, label: string }[]
  }>();

  constructor(public storage: StorageService, public router: Router, public traceService: TraceService) {
  }

  goTo(step: Step, metadata: Date | { date: Date, caller: string }, options?: NavigationExtras | undefined) {
    let k = Object.keys(metadata)
    let caller = ''
    if (k.includes('caller')) {
      caller = (<any>metadata).caller
    } else {
      try {
        throw new Error
      } catch (error: any) {
        caller = error.stack.split('\n')[2]
      }
    }
    this.traceService.pageNavigateStart(JSON.stringify({ PageName: step.key, Invoker: caller, NavUrl: step.url, Severity: 'info', IsUrgentTrace: false }))
    return this.router.navigate([step.url], options).finally(() => {
      this.traceService.pageNavigation(step.key, caller, 'info', step.key, step.url, false)
      this.navigate$.next(step)
    })
  }

  getStep<K extends StepKey>(key?: K | null) {
    let step = this.steps.find((step) => {
      let url = this.router.url.split('?')[0]
      return key ? step.key == key : step.url == url
    })
    if (!step) {
      throw new Error("Invalid step");
    }
    return step;
    //  as FilteredStep<Steps, K, "key">[number]
  }

  next(time: Date) {
    let step = this.getStep()
    let next = this.getStep(step.next)
    return this.goTo(next, time)
  }

  back(time: Date) {
    let step = this.getStep()
    return this.goTo(this.getStep(step.prev), time)
  }

  exit() {
    return this.goTo(this.getStep('WELCOME'), new Date)
  }

  start(step?: Step) {
    return this.goTo(step || this.getStep('WELCOME'), new Date)
  }

  goToResult(data: ({ receipt?: boolean, caller?: string } & ({ success: true, message: string } | { success: false, error: string }))) {
    this.storage.set<any>("result", { "ResponseCode": data.success ? "0000" : "0001", ResponseMessage: data.success ? data.message : '', error_message: !data.success ? data.error : '', isInitial: typeof data.receipt == "undefined" ? true : data.receipt })
    return this.goTo(this.getStep('RESULT'), { date: new Date, caller: data.caller || '' })
  }
}
